import { Theme } from "../types/profile";

export const applyTheme = (themeData: Theme) => {
  document.documentElement.style.setProperty("--backgroundcolor", themeData.backgroundColor);
  document.documentElement.style.setProperty("--font-color", themeData.fontColor);
  document.documentElement.style.setProperty("--font-family", themeData.fontFamily);
};
